import React, { Fragment, forwardRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlus,
  faEnvelope,
  faStickyNote,
} from '@fortawesome/free-solid-svg-icons';
import { Button, Col, Row, Table } from 'reactstrap';

const blockEl = 'invoices__create-new-invoices';

const PrintableCreateInvoices = forwardRef((props, ref) => {
  const { invoices,
    getOutstandingBalancePerInvoice,
    getInvoiceDetailStatus
  } = props;
  return (
    <div ref={ref} className="px-3">
      {invoices.map((invoice, index) => (
        <Fragment key={invoice.invoiceID}>
          <Row className={`${blockEl}__invoice`}>
            <Col xs="12">
              <Row>
                <Col>
                  <Row className={`${blockEl}__invoice-details`}>
                    <Col xs="12">
                      <Row
                        className={`${blockEl}__invoice-details__name`}
                      >
                        <Col>
                          <h3>
                            {invoice.lastName}, {invoice.firstName}
                          </h3>
                        </Col>
                        <Col xs="9">
                          <Row
                            className={`${blockEl}__invoice-details__actions`}
                          >
                            <Col xs="4">
                              <Button
                                color="link"
                              >
                                <FontAwesomeIcon icon={faPlus} />
                                Edit/Add charges
                              </Button>
                            </Col>
                            <Col xs="2">
                              <Button
                                color="link"
                              >
                                <FontAwesomeIcon icon={faEnvelope} />
                                Contact
                              </Button>
                            </Col>
                            <Col xs="4">
                              <Button
                                color="link"
                              >
                                <FontAwesomeIcon icon={faStickyNote} />
                                Add internal note
                              </Button>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                    <Col xs={12}>
                      <p>
                        #{invoice.invoiceID} | {invoice.city},{' '}
                        {invoice.state || invoice.province},{' '}
                        {invoice.country}
                      </p>
                    </Col>
                  </Row>
                </Col>
                <Col xs="3" className={`${blockEl}__invoice-balance`}>
                  <Row>
                    <Col xs="12">
                      <h4>Outstanding Balance</h4>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={{ size: 'auto', offset: 2 }}>
                      <p>
                        $
                        {getOutstandingBalancePerInvoice(
                          invoice.invoiceID
                        )}
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
            <Col xs="12">
              <Row>
                <Table
                  bordered
                  className={`${blockEl}__invoice__amounts`}
                >
                  <thead>
                    <tr>
                      <th>Session</th>
                      <th>Lot</th>
                      <th>Hammer</th>
                      <th>BP</th>
                      <th>Live Fee</th>
                      <th>Tax</th>
                      <th>Total</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {invoice.invoiceDetails
                      && invoice.invoiceDetails.length
                      ? invoice.invoiceDetails.map((invoiceDetail) => (
                        <tr
                          key={invoiceDetail.invoiceDetailID}
                          className={`${blockEl}__invoice__item`}
                        >
                          <td>{invoiceDetail.saleIdentifier}</td>
                          <td>
                            <Button color="link">
                              <a href={invoiceDetail.lotURL}>
                                {invoiceDetail.lotNum}
                                {invoiceDetail.lotNumExt}
                              </a>
                            </Button>
                          </td>
                          <td>
                            <Row>
                              <Col>$</Col>
                              <Col>
                                {invoiceDetail.priceInfo.hammer}
                              </Col>
                            </Row>
                          </td>
                          <td>
                            <Row>
                              <Col>$</Col>
                              <Col>
                                {invoiceDetail.priceInfo.premium}
                              </Col>
                            </Row>
                          </td>
                          <td>
                            <Row>
                              <Col>$</Col>
                              <Col>
                                {invoiceDetail.priceInfo.livefee}
                              </Col>
                            </Row>
                          </td>
                          <td>
                            <Row>
                              <Col>$</Col>
                              <Col>{invoiceDetail.priceInfo.tax}</Col>
                            </Row>
                          </td>
                          <td>
                            <Row>
                              <Col>$</Col>
                              <Col>
                                {invoiceDetail.totalInvoiceAmount}
                              </Col>
                            </Row>
                          </td>
                          <td>
                            {getInvoiceDetailStatus(
                              invoice.invoiceSentDate,
                              invoiceDetail.shippedDate,
                              invoiceDetail.paidDate
                            )}
                          </td>
                        </tr>
                      ))
                      : null}
                  </tbody>
                </Table>
              </Row>
            </Col>
          </Row>
          {index < (invoices.length) && (
            <div className="page-break" />
          )}
        </Fragment>
      ))}
    </div>
  );
});

export default PrintableCreateInvoices;
